import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../helpers/reducerRegistry'
import { getInternationalCompanyDetail, getProducts } from './thunk'

const slice = createSlice({
  name: 'internationalSearch/preview',
  initialState: {
    companyInfoData: {},
    reportData: [],
    loading: false,
    reportLoading: false,
  },
  reducers: {
    resetCompany: (state) => {
      state.companyInfoData = {}
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getInternationalCompanyDetail.pending, (state) => {
      state.loading = true
    })
    builder.addCase(
      getInternationalCompanyDetail.fulfilled,
      (state, action) => {
        state.companyInfoData = action.payload
        state.loading = false
      },
    )
    builder.addCase(getInternationalCompanyDetail.rejected, (state, action) => {
      state.loading = action.payload.loading
    })
    builder.addCase(getProducts.pending, (state) => {
      state.reportLoading = true
    })
    builder.addCase(getProducts.fulfilled, (state, action) => {
      state.reportData = action.payload
      state.reportLoading = false
    })
    builder.addCase(getProducts.rejected, (state, action) => {
      state.reportLoading = action.payload.loading
    })
  },
})

export const { resetCompany } = slice.actions

export const selectCompanyInfoData = (state) =>
  state[slice.name].companyInfoData
export const selectReportData = (state) => state[slice.name].reportData
export const selectLoading = (state) => state[slice.name].loading
export const selectReportLoading = (state) => state[slice.name].reportLoading

register(slice.name, slice.reducer)
